let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dT86q")).then(() => parcelRequire('18zQo'));